import { render, staticRenderFns } from "./CanvasSegmentationContiniousMode.vue?vue&type=template&id=7226058a&scoped=true&"
import script from "./CanvasSegmentationContiniousMode.vue?vue&type=script&lang=ts&"
export * from "./CanvasSegmentationContiniousMode.vue?vue&type=script&lang=ts&"
import style0 from "./CanvasSegmentationContiniousMode.vue?vue&type=style&index=0&id=7226058a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7226058a",
  null
  
)

export default component.exports